
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false
import apiUrl from '../config/api'
import store from './store'
import MintUi from 'mint-ui'
import {Indicator, MessageBox} from 'mint-ui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import '../config/request'
import qs from 'qs'
import {currency, addCommaSpecific, formatDate, formatDay} from '../config/util/filter'
import moment from 'moment/moment'
import 'mint-ui/lib/style.css'
import md5 from 'js-md5'
import Vant from 'vant';
import 'vant/lib/index.css';
import less from 'less' 

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

// import MathLive from "./mathlive.js";
// import Mathfield from "./vue-mathlive.mjs";
// Vue.use(Mathfield, MathLive);

Vue.use(VideoPlayer)
Vue.use(Vant);
// import './common/font/font.css'
Vue.use(less)
Vue.use(ElementUI);
Vue.use(MintUi);
Vue.filter('currency', currency);
Vue.filter('toFixedTwo', addCommaSpecific);
Vue.filter('formatDate', formatDate);
Vue.filter('formatDay', formatDay);
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;
Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$Indicator = Indicator;

global.apiUrl = apiUrl;
router.beforeEach((to, from, next) => {
	if(to.meta.title){
		document.title = to.meta.title;
	}
	next()
})
global.baseUrl = process.env.API_ROOT;
global.newBaseUrl = process.env.NEW_API_ROOT;
Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYYMMDD';
    // return moment(value).format(formatString); // value可以是普通日期 20170723
    return moment(value).format(formatString); // 这是时间戳转时间
});
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js